import React from 'react';
import scroll from 'utilities/scroll';
import { getValue } from 'utilities/helperFunctions';

export const RadioButtonOption = ({
    additionalComponent,
    change,
    disabled,
    focusAnimated,
    id,
    label,
    model,
    modelProp,
    onChange,
    onFocus,
    onKeyDown,
    paymentStyle,
    profileModel,
    setTrigger,
    setValidity,
    showAlwaysAdditionalComponent,
    userProfile,
    value,
}) => {
    const handleOnChange = event => {
        const { value } = event.target;

        change(profileModel, value);
        setValidity(profileModel, { required: true }); // Is valid if selected.
        setTrigger(true);

        onChange?.(value);
    };

    const onFocusAnimate = () => {
        const element = document.getElementById(`id_wrapper_${modelProp}`);
        element && scroll.transition(element);
    };

    const handleOnFocus = () => {
        focusAnimated && onFocusAnimate();
        onFocus?.();
    };
    const getUserProfileValue = () => {
        const [parent, ...rest] = profileModel.split('.').slice(1);
        const value = userProfile[parent];

        return value && model ? getValue(value, rest) : value;
    };

    const userProfileValue = getUserProfileValue();
    const checked = userProfileValue === value.toString();
    const shouldShowAdditionalComponent = additionalComponent && (checked || showAlwaysAdditionalComponent);

    return (
        <li key={id}>
            <input
                className="form__radio"
                type="radio"
                id={id}
                name={modelProp}
                defaultValue={value}
                onChange={handleOnChange}
                checked={checked}
                onKeyDown={onKeyDown}
                disabled={disabled}
                onFocus={handleOnFocus}
            />
            <label className="sub-label" htmlFor={id} style={paymentStyle}>
                {label}
            </label>
            <div className={`radio-additional-component ${shouldShowAdditionalComponent ? '' : 'd-none'}`}>
                {additionalComponent}
            </div>
        </li>
    );
};
